import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import axios from "axios";
// @mui
import {
  Card,
  Stack,
  Button,
  Typography,
  Grid,
  Box,
  DialogContent,
  Divider,
  DialogTitle,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { onCloseModalForUserReservationDetail } from "src/redux/slices/customerReservationSlice";
import { useAuthContext } from "src/auth/useAuthContext";
import { useSnackbar } from "src/components/snackbar";
import moment from "moment-timezone";

import Iconify from "../../../../components/iconify";

const CountryCode = process.env.REACT_APP_COUNTRY_CODE;
UserReservationDetailModal.propTypes = {
  sx: PropTypes.object,
  title: PropTypes.string,
  subheader: PropTypes.string,
  onClose: PropTypes.func,
  singleData: PropTypes.array,
  onOrderAdd: PropTypes.func,
  getTable: PropTypes.func,
  modalTableData: PropTypes.func,
};

export default function UserReservationDetailModal({
  singleData,
  onOrderAdd,
  getTable,
  modalTableData,
  title,
  onClose,
  subheader,
  sx,
  ...other
}) {
  const dispatch = useDispatch();
  const { venue } = useSelector((state) => state.venue);

  const { user } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();

  const formatTime = (time) => {
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    return new Intl.DateTimeFormat("en-US", options).format(time);
  };

  const formatDate = (time) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Intl.DateTimeFormat("en-US", options).format(time);
  };

  const handleCloseModal = () => {
    dispatch(onCloseModalForUserReservationDetail());
  };

  const [remainingAmount, setRemainingAmount] = useState(
    singleData?.advancePayment?.amount - (singleData?.refundedAmount || 0)
  );

  let [disabledAmountButton, setDisabledAmoutButton] = useState(false);

  const [transactions, setTransactions] = useState([]);
  const fetchTransactions = async () => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const getToken = sessionStorage.getItem("accessToken");
    try {
      const response = await axios.get(
        `${backendUrl}/transaction/byReservationId/${singleData?.id}`,
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
          params: {
            transactionStatus: "Refunded",
          },
        }
      );
      setTransactions(response?.data?.results);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      enqueueSnackbar("Failed to fetch transactions", { variant: "error" });
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const handleRefundUpdate = (refAmount) => {
    setRemainingAmount(singleData?.advancePayment?.amount - refAmount);
    fetchTransactions();

    if (refAmount == singleData?.advancePayment?.amount) {
      setDisabledAmoutButton(true);
    }
  };

  const customerData =
    singleData?.origin === "web"
      ? singleData?.customerId
      : singleData?.customer;


  return (
    <>
      <Card
        sx={{
          boxShadow: 0,
          bgcolor: "background.neutral",
          ...sx,
        }}
        {...other}
      >
        <DialogTitle>
          <Grid>
            <Stack
              direction="row"
              sx={{ mb: -1 }}
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" justifyContent="left">
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  startIcon={
                    <Iconify
                      sx={{
                        right: -5,
                        position: "relative",
                        width: 30,
                        height: 30,
                      }}
                      icon="emojione-monotone:cross-mark"
                    />
                  }
                  sx={{
                    borderRadius: 2,
                    minWidth: 60,
                    minHeight: 60,
                    ml: -2,
                    mt: -2,
                    mb: 1,
                  }}
                  onClick={handleCloseModal}
                />
              </Stack>
              <Stack
                direction="row"
                sx={{ mt: -2, ml: -6 }}
                justifyContent="center"
              >
                <Typography variant="h6">Reservation detail</Typography>
              </Stack>
              <Stack direction="row" justifyContent="right" />
            </Stack>
          </Grid>
        </DialogTitle>
      </Card>

      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ mt: 2, ml: 2, mb: 4 }}>
              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={1.5}
                mt={3}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Date:</Typography>
                <Typography variant="body2">
                  {formatDate(new Date(singleData?.createdAt))}
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Time:</Typography>
                <Typography variant="body2">
                  {" "}
                  {formatTime(new Date(singleData?.createdAt))}
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Reservation #:</Typography>
                <Typography variant="body2">
                  {singleData?.reservationNo ? singleData?.reservationNo : "-"}
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Status:</Typography>
                <Typography variant="body2">
                  {singleData?.status ? singleData?.status : "-"}
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Origin:</Typography>
                <Typography variant="body2">
                  {singleData?.origin ? singleData?.origin : "-"}
                </Typography>
              </Box>
              <Divider />
              {/* <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Name:</Typography>
                <Typography variant="body2">
                  {singleData?.customer?.firstName ||
                  singleData?.customer?.lastName
                    ? `${singleData?.customer?.firstName || ""} ${
                        singleData?.customer?.lastName || ""
                      }`.trim()
                    : "-"}
                </Typography>
              </Box>
              <Divider />

              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Phone Number:</Typography>
                <Typography variant="body2">
                 {CountryCode} {singleData?.customer?.phone
                    ? singleData?.customer?.phone
                    : "-"}
                </Typography>
              </Box>
              <Divider />

              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Email:</Typography>
                <Typography variant="body2">
                  {singleData?.customer?.email
                    ? singleData?.customer?.email
                    : "-"}
                </Typography>
              </Box>
              <Divider /> */}

              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Name:</Typography>
                <Typography variant="body2">
                  {customerData?.firstName || customerData?.lastName
                    ? `${customerData?.firstName || ""} ${
                        customerData?.lastName || ""
                      }`.trim()
                    : "-"}
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Phone Number:</Typography>
                <Typography variant="body2">
                  {CountryCode}{" "}
                  {customerData?.phone ? customerData?.phone : "-"}
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Email:</Typography>
                <Typography variant="body2">
                  {customerData?.email ? customerData?.email : "-"}
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Party Size:</Typography>
                <Typography variant="body2">
                  {singleData?.partySize ? singleData?.partySize : "-"}
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={{ display: "flex", justifyContent: "space-between" }}
                mb={2}
                mt={2}
                ml={3}
                mr={3}
              >
                <Typography variant="body2">Reservation Type:</Typography>
                <Typography variant="body2">
                  {singleData?.reservationType
                    ? singleData?.reservationType
                    : "-"}
                </Typography>
              </Box>
              <Divider />
              {singleData?.advancePayment?.amount && (
                <>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                    mb={2}
                    mt={2}
                    ml={3}
                    mr={3}
                  >
                    <Typography variant="body2">Payment Type:</Typography>
                    <Typography variant="body2">
                      {singleData?.paymentType ? singleData?.paymentType : "-"}
                    </Typography>
                  </Box>
                  <Divider />

                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                    mb={2}
                    mt={2}
                    ml={3}
                    mr={3}
                  >
                    <Typography variant="body2">Advance Amount:</Typography>
                    <Typography variant="body2">
                      Rs.{" "}
                      {singleData?.advancePayment?.amount
                        ? singleData?.advancePayment?.amount
                        : "-"}
                    </Typography>
                  </Box>
                  <Divider />
                </>
              )}
              {singleData?.checkinTime && (
                <>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                    mb={1}
                    mt={1}
                    ml={3}
                    mr={3}
                  >
                    <Typography variant="body2">Check-In Time:</Typography>
                    {moment(singleData.checkinTime)
                      .utc()
                      .format("MMM D, YYYY h:mm A")}
                  </Box>
                  <Divider />
                </>
              )}
              {singleData?.checkoutTime && (
                <>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                    mb={1}
                    mt={1}
                    ml={3}
                    mr={3}
                  >
                    <Typography variant="body2">Check-Out Time:</Typography>
                    {moment(singleData.checkoutTime)
                      .utc()
                      .format("MMM D, YYYY h:mm A")}
                  </Box>
                  <Divider />
                </>
              )}
              {singleData?.reasonOfCancel && (
                <>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                    mb={2}
                    mt={2}
                    ml={3}
                    mr={3}
                  >
                    <Typography variant="body2">Reason Of Cancel:</Typography>
                    <Typography variant="body2">
                      {singleData?.reasonOfCancel
                        ? singleData?.reasonOfCancel
                        : "-"}
                    </Typography>
                  </Box>
                  <Divider />
                </>
              )}
              <>
                {transactions?.length > 0 &&
                  transactions?.map((transaction) => (
                    <>
                      <Box
                        key={transaction?._id}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                          mt: 1,
                          ml: 3,
                          mr: 3,
                        }}
                      >
                        <Typography variant="body2">
                          Amount Refunded:
                        </Typography>
                        <Typography variant="body2">
                          Rs.{" "}
                          {Number(transaction?.refundedAmount || 0).toFixed(2)}{" "}
                          at{" "}
                          {moment(transaction?.createdAt).format(
                            "MMM D, YYYY h:mm A"
                          )}
                        </Typography>
                      </Box>
                      <Divider />
                    </>
                  ))}
              </>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
    </>
  );
}
